<template>
  <v-container>
    <div class="display-2">Import údajov zo súborov xls</div>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1"
          >Upload súboru</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >Kontrola súboru</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="3">Import údajov</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container class="ma-5">
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-select
                  v-model="imp"
                  :items="impTyp"
                  label="Typ importu"
                ></v-select>
              </v-row>

              <v-row v-if="imp === 'lokality'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    lokalitách.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      ID_lokality, Lokalita, Skratka, ZUJ, ZM50, IG_region,
                      IG_oblast, Plocha, Jednotka, Nadm_vyska, Sklon,
                      Objem_zosuvu, Zac_mer, Popis, Popis1, Popis2, Literat1,
                      Literat2, Literat3, Literat4, Literat5, Literat6, Literat7
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'body'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      EXPORT, ID_LOKALITY, ID_MB, ID_MB_P, ZNACKA, DATUM_OD,
                      DATUM_DO, Y_JTSK, X_JTSK, Z_JTSK, Z_PAZNICE, RURA,
                      Poznamka
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbink'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, AZIMUT, DATUM_OD, DATUM_DO, POZNAMKA,
                      HLBKA_INC, X_SERIA_N, X_INSTAL_R, X_INSTAL_T, X_FAKTOR_G,
                      Y_SERIA_N, Y_INSTAL_R, Y_INSTAL_T, Y_FAKTOR_G, TYP
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'inkp'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, HLBKA, M_A, M_B, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'inks'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, IND, X, Y, T_X, T_Y, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbpt'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    merania.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM_OD, DATUM_DO, POZNAMKA, P1_DATUM,
                      P1_HLBKA, P1_SERIA_N, P1_INSTAL_R, P1_INSTAL_T,
                      P1_FAKTOR_G, P1_FAKTOR_K, P2_DATUM, P2_HLBKA, P2_SERIA_N,
                      P2_INSTAL_R, P2_INSTAL_T, P2_FAKTOR_G, P2_FAKTOR_K
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'pt'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, IND, P_1, P_2, TP_1, TP_2, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'dilat'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje dva hárky: informácie o
                    meraniach a inštalácii.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť pre meranie:<br />
                    <span class="font-weight-bold">
                      L, B, DATUM, TEPLOTA, POZNAM, ZMENA, VAZBA, VERZAP,
                      HORZAP, VVC, VMC, VSMER, VR200, VR200D, VR300, VR300D,
                      HVC, HMC, HSMER, HR200, HR200D, HR300, HR300D </span
                    ><br />
                    a pre inštaláciu:<br />
                    <span class="font-weight-bold">
                      LOKALITA, DATUM, GS, FS, GX, FX, IR, IKV, IKM, DKX, DKY,
                      DKZ, XHORE, ZHORE, LAVOTOC, ROT, XMAS, MALK, CT, B
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbhpv'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    merani.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM_OD, DATUM_DO, POZNAMKA, PAZNICA,
                      PISTALA, SPOS_HPV, INDIK
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'hpv'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, HPV, HPV_T, TYP_MON, POZNAMKA, KOD_P
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbmikroniv'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, ZN_MB, LITOL_M1, LITOL_M2, LITOL_M3, LITOL_M4,
                      LITOL_M5, LITOL_M6, LITOL_M7, LITOL_M8, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mikroniv'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, ZN_MB, DATUM, M1, M2, M3, M4, M5, M6, M7, M8
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbstabskal'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, ZN_MB, DATUM_OD, DATUM_DO, POZNÁMKA, ETALON,
                      ZN_STACIO_MB
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'stabskal'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, ZN_MB, DATUM, ETAL_ROZM, TEPLOTA, E0_1, E0_2,
                      E0_3, EMAX_1, EMAX_2, EMAX_3, MER_LD_1, MER_LD_2,
                      MER_LD_3, MER_PH_1, MER_PH_2, MER_PH_3, AVR_E (CIACH),
                      KOEF_STACIO (STACIO_VZD), DILAT_STC, DILAT_TPL, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'mbpotrub'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o bodoch
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      B, DATUM_OD, DATUM_DO, POZNAMKA, NAZOV, STANOV, ZAKLAD_V,
                      ZAKLAD_H
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'potrub'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, STANIČENIE, DATUM, POZNAMKA, ETAPA,
                      TEPLOT_V, VYSKA_N, 1_M_V, 2_M_V, 1_M_H, 2_M_H, TEPLOTA_1,
                      TEPLOTA_2, KONTROL_1, KONTROL_2, KONTROL_3, KONTROL_4
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'geodezia'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      L, B, DATUM, X, Y, Z, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'hpvq'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:<br />
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, OBJEM, CAS, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'peep'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, HLBKA_OD, P_1, P_2, P_3, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'pees'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, HLABKA_OD, HLABKA_DO, PEE, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'prna'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:
                    <span class="font-weight-bold">
                      LOKALITA, BOD, DATUM, SIGMA_1, SIGMA_2, SIGMA_3, SIGMA_4,
                      POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'stanice'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o staniciach
                    SHMÚ.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:
                    <span class="font-weight-bold">
                      STANICA, LOKALITA1, LOKALITA2, LOKALITA3, LOKALITA4,
                      LOKALITA5, INDIKATIV
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'zrazky'">
                <v-col>
                  <div class="body-1">
                    Import Excel súboru, ktorý obsahuje informácie o
                    meraniach.<br />
                    Súbor musí mať stĺpce, ktoré majú v prvom riadku názvy
                    stĺpcov.<br />
                    Tieto názvy stĺpcov musia byť:
                    <span class="font-weight-bold">
                      STANICA_SHMU, INDIKATÍV, DATUM, TYP_V, ZRAZKY, TEPLOTA_P,
                      TEPLOTA_MX, TEPLOTA_MN, POCET_M, POZNAMKA
                    </span>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'insar'">
                <v-col>
                  <div class="body-1">
                    Import súboru, ktorý obsahuje informácie o meraniach
                    InSAR.<br />
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="imp === 'insar'">
                <v-col>
                  <v-autocomplete
                    label="Lokalita"
                    v-model="lokalitaID"
                    :items="lokality"
                    item-text="Name"
                    item-value="ID"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
                <v-col>
                  <v-file-input
                    label="Import súboru"
                    show-size
                    prepend-icon="mdi-file"
                    @change="onFileChange"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-file-input
                  label="Import súboru"
                  show-size
                  accept=".xlsx"
                  prepend-icon="mdi-file-excel"
                  @change="onFileChange"
                ></v-file-input>
              </v-row>
              <v-btn
                v-if="xfile && imp"
                color="primary"
                @click="fileUpload()"
                :loading="loading"
                :disabled="loading"
              >
                <v-icon class="mr-2">mdi-file-upload</v-icon>Upload
              </v-btn>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2">
          <div class="title">Informácie po načítaní zo súboru:</div>
          <v-sheet color="red lighten-4 my-2">
            <div v-for="t in errors" class="body-2 pa-2" :key="t">{{ t }}</div>
          </v-sheet>
          <v-sheet color="orange lighten-4 my-2">
            <div v-for="t in messages" class="body-2 pa-2" :key="t">
              {{ t }}
            </div>
          </v-sheet>
          <v-btn color="secondary" @click="step = 1">
            <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>Späť
          </v-btn>
          <v-btn
            color="primary"
            @click="importovat()"
            class="ml-2"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon class="mr-2">mdi-file-upload</v-icon>Importovať
          </v-btn>
        </v-stepper-content>
        <v-stepper-content step="3">
          <div class="title">Informácie z importu súboru:</div>
          <v-sheet color="red lighten-4 my-2">
            <div v-for="t in errors" class="body-2 pa-2" :key="t">{{ t }}</div>
          </v-sheet>
          <v-sheet color="orange lighten-4 my-2">
            <div v-for="t in messages" class="body-2 pa-2" :key="t">
              {{ t }}
            </div>
          </v-sheet>
          <v-btn color="primary" @click="again">
            <v-icon class="mr-2">mdi-arrow-left-circle</v-icon>Nový import
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    step: 1,
    valid: true,
    lokality: [],
    lokalitaID: null,
    //step1
    xfile: null,
    imp: null,
    loading: false,
    impTyp: [
      { value: "lokality", text: "Lokality" },
      { value: "body", text: "Body" },
      { value: "mbink", text: "Inklinometria - body" },
      { value: "inkp", text: "Inklinometria prenosná" },
      { value: "inks", text: "Inklinometria stacionárna" },
      { value: "mbpt", text: "Pórových tlakov - body" },
      { value: "pt", text: "Pórových tlakov" },
      { value: "dilat", text: "Dilatometrické - skalné bloky" },
      { value: "mbhpv", text: "Hladiny podz.vody - body" },
      { value: "hpv", text: "Hladiny podz.vody" },
      { value: "mbpotrub", text: "Pr.rozm.zmien potrubia - body" },
      { value: "potrub", text: "Pr.rozm.zmien potrubia" },
      { value: "mbmikroniv", text: "Mikromorfologické - body" },
      { value: "mikroniv", text: "Mikromorfologické" },
      { value: "mbstabskal", text: "Dilatometrické (StabSkal) - body" },
      { value: "stabskal", text: "Dilatometrické (StabSkal)" },
      { value: "geodezia", text: "Geodetické" },
      { value: "hpvq", text: "Prietokov" },
      { value: "peep", text: "PEE primárne" },
      { value: "pees", text: "PEE sekundárne" },
      { value: "prna", text: "Povrchové reziduálne" },
      { value: "stanice", text: "SHMÚ Stanice" },
      { value: "zrazky", text: "Zrážky" },
      { value: "insar", text: "InSAR" }
    ],

    //step 2
    fileid: null,
    messages: [],
    errors: []
  }),

  components: {},

  methods: {
    onFileChange: function(e) {
      console.log("file change", e)
      this.xfile = e
    },
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    fileUpload: async function() {
      this.loading = true
      this.messages = []
      this.errors = []
      console.log("file upload", this.xfile)
      let formData = new FormData()
      formData.append("imptype", this.imp)
      formData.append("file", this.xfile)
      try {
        let response = await this.$axios.post(
          "/r/uploadxls?lokalitaId=" + this.lokalitaID,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        if (response.status === 200) {
          this.$store.commit("message", "Súbor načítaný")
          this.messages = response.data.messages
          this.fileid = response.data.fileid
          this.errors = response.data.errors
          this.step = 2
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    },

    importovat: async function() {
      this.loading = true
      this.messages = []
      this.errors = []
      try {
        let response = await this.$axios.get("/r/importxls/" + this.fileid)
        if (response.status === 200) {
          this.$store.commit("message", "Import údajov ukončený")
          this.messages = response.data.messages
          this.errors = response.data.errors
          this.step = 3
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    },

    again: function() {
      this.step = 1
      this.messages = []
      this.errors = []
      this.xfile = null
      this.imp = null
      this.$refs.form.reset()
    }
  },

  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
  }
}
</script>
